const IsLinkMatchPath = (location, path) => location?.pathname?.includes(path);

export default IsLinkMatchPath;

